// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ffFJ","content":"LoadingAlert_content__2rvSO"};